import { svg } from "../svg";

const PasswordManagerLogo = svg`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 49" fill="none">
    <defs>
      <linearGradient id="gxpms-pm-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#2563EB"/>
        <stop offset="100%" stop-color="#06B6D4"/>
      </linearGradient>
    </defs>
    <path d="M 21 5 L 37.5 14.5 L 37.5 33.5 L 21 43 L 4.5 33.5 L 4.5 14.5 Z" fill="url(#gxpms-pm-grad)"/>
    <path d="M 21 15 L 25.5 19.5 L 21 24 L 16.5 19.5 Z" fill="#FFFFFF"/>
    <path d="M 19.2 22 L 22.8 22 L 23.5 32 L 18.5 32 Z" fill="#FFFFFF"/>
    <path d="M 4.5 24 L 11 24 L 13 22" stroke="#FFFFFF" stroke-width="1" fill="none" opacity="0.7" stroke-linecap="round"/>
    <circle cx="4.5" cy="24" r="1.3" fill="#FFFFFF" opacity="0.7"/>
    <path d="M 37.5 24 L 31 24 L 29 22" stroke="#FFFFFF" stroke-width="1" fill="none" opacity="0.7" stroke-linecap="round"/>
    <circle cx="37.5" cy="24" r="1.3" fill="#FFFFFF" opacity="0.7"/>
    <text x="46" y="31" font-family="'Segoe UI', 'Helvetica Neue', Arial, sans-serif" font-size="26" font-weight="bold" fill="url(#gxpms-pm-grad)">GXPMS</text>
  </svg>
`;

export default PasswordManagerLogo;
